// Central registry of localStorage keys, so they can't silently collide or drift
// and are easy to audit in one place. All app keys are prefixed "omni_hub".
export const STORAGE_KEYS = {
  /** Sidebar collapsed/expanded state. */
  sidebarCollapsed: "omni_hub_sidebar_collapsed",
  /** The chat widget's persisted session id for "Chat about this page". */
  chatSessionId: "omni_hub_chat_session_id",
  /** The chat widget's persisted session id for "Suggest an improvement". */
  improveSessionId: "omni_hub_improve_session_id",
  /** Cached Okta tokens (id/refresh/expiry) for the SPA PKCE session. */
  authToken: "omni_hub_token",
  /** The default Omni Hub sign-in identity used off-Okta (name + email). */
  localUser: "omni_hub_local_user",
  /** Agents Hub context-column width (px). */
  contextWidth: "omni_hub.agentHub.contextWidth",
  /** Light/dark theme for the main app chrome. */
  theme: "omni_hub_theme",
  /**
   * Editor title/body parked across an Okta reauth redirect, so a session that
   * expires mid-edit doesn't take the work with it. Written ONLY when the
   * pre-expiry save couldn't land, and consumed by the editor the next time that
   * same draft is opened.
   */
  editorRescue: "omni_hub_editor_rescue",
  /**
   * Whether the Sync ▸ SDKs "Changed in this release" list is collapsed.
   *
   * Per viewer and per browser, which is exactly what this list is: a reviewer
   * who wants the screen space wants it on every page of the batch, not once
   * (ENG-55485). Nothing depends on it — an unreadable or absent value just means
   * expanded, which is the useful default.
   */
  sdkSectionsCollapsed: "omni_hub_sdk_sections_collapsed",
  /** The DevHub doc menu, collapsed to a strip — the width a writer gives back to
   *  the page when the feedback rail has none left to take (ENG-55787). */
  devhubNavCollapsed: "omni_hub_devhub_nav_collapsed",
  /** Whether a release batch's Polaris "Launch" section is folded to its header.
   *  One preference for every batch — the space is wanted on each one opened, not
   *  once (ENG-58082). Absent reads as FOLDED; see devhub/lib/launchCollapse.ts. */
  devhubBatchLaunchCollapsed: "omni_hub_devhub_batch_launch_collapsed",
} as const;
